// Toggle Editing Function
export const toggleEditing = (setIsEditing, field, rowID) => {
    setIsEditing(prevState => ({
        ...prevState,
        [rowID]: {
            ...prevState[rowID],
            [field]: !prevState[rowID]?.[field]
        }
    }));
};

// Custom Styles for Lookup
export const customSelectStyles = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
        borderRadius: "10px",
        border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),

    placeholder: (styles) => ({
        ...styles,
        color: 'gray',
    }),
    singleValue: (styles, { data }) => ({
        ...styles,
        color: 'black',
        backgroundColor: 'white',
    }),
    option: (styles, { isSelected, isFocused }) => ({
        ...styles,
        backgroundColor: isSelected
            ? '#f1e9e9'
            : isFocused
                ? '#f1e9e9'
                : 'white',
        color: isSelected ? '#666' : '#333',
    }),
};
// Common function to close editing for any field
// src/components/utils/commonFunction/CommonFunction.js
export const closeEdit = (setIsEditing, field, rowID) => {
    setIsEditing(prevState => ({
        ...prevState,
        [rowID]: {
            ...prevState[rowID],
            [field]: false
        }
    }));
};


// //to convert yy-mm-dd to dd-mm-yy
// export const formatDate = (dateString) => {
//     if (!dateString) {
//         return "";
//     }
//     if (dateString?.includes(' ')) {
//         const [datePart, timePart] = dateString.split(' ');
//         const date = new Date(datePart);
//         const [hours, minutes] = timePart.split(':');
//         const day = ("0" + date.getDate()).slice(-2);
//         const month = ("0" + (date.getMonth() + 1)).slice(-2);
//         const year = date.getFullYear();

//         return `${day}-${month}-${year} ${hours}:${minutes}`;
//     } else {
//         const date = new Date(dateString);
//         const day = ("0" + date.getDate()).slice(-2);
//         const month = ("0" + (date.getMonth() + 1)).slice(-2);
//         const year = date.getFullYear();
//         return `${day}-${month}-${year}`;
//     }
// };



export const formatDate = (dateString) => {
    if (!dateString) {
        return "";
    }
    
    // Convert to string if it's a Date object
    const str = typeof dateString === 'string' ? dateString : dateString.toString();
    
    try {
        if (str.includes(' ')) {
            const [datePart, timePart] = str.split(' ');
            const date = new Date(datePart);
            const [hours, minutes] = timePart.split(':');
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        } else {
            const date = new Date(str);
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    } catch (e) {
        console.error("Error formatting date:", e);
        return "";
    }
};

// custom style for lookup
export const customStyle = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? "silver" : "rgb(93, 135, 255)",
        borderRadius: "10px",
        border: "0.5px solid rgb(196,196,196,0.5) !important",
    }),

    placeholder: (styles) => ({
        ...styles,
        color: "gray",
    }),
    singleValue: (styles, { data }) => ({
        ...styles,
        color: "black",
        backgroundColor: "white",
    }),
    option: (styles, { isSelected, isFocused }) => ({
        ...styles,
        backgroundColor: isSelected ? "#f1e9e9;" : isFocused ? "#f1e9e9;" : "white",
        color: isSelected ? "#666" : "#333",
    }),
};

export function toTitleCase(str) {
    return str
        ?.toLowerCase()
        ?.split(' ')
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
        ?.join(' ');
}